@let channel = activeChannel$ | async;

<button type="button" #channelInfoDrawerButton command="show-modal" commandfor="channelInfoDrawer"
  class="btn-fab-secondary text-secondary" aria-label="Open channel details">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
</button>

<el-dialog>
  <dialog #channelInfoDrawerDialog id="channelInfoDrawer" aria-labelledby="channelInfoDrawer-title"
    class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
    <el-dialog-backdrop (click)="closeDrawer()"
      class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
    </el-dialog-backdrop>
    <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
      (click)="$event.stopPropagation()">
      <el-dialog-panel
        class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
        (click)="$event.stopPropagation()">
        <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl">
          <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
            <div class="px-2 py-4 drawer-header-primary">
              <div class="flex space-x-3 h-full items-center">
                <div class="min-w-0 flex-1 px-2">
                  @if (channel) {
                  <p id="channelInfoDrawer-title" class="text-md font-semibold text-primary">
                    {{ channelName(channel) }}
                  </p>
                  <p class="text-sm text-secondary">
                    @if (createdAtDate(channel); as created) {
                    Created {{ created | date: "dd MMM yyyy" }}
                    } @else {
                    <span>Created —</span>
                    }
                  </p>
                  } @else {
                  <p id="channelInfoDrawer-title" class="text-md font-semibold text-primary">Channel</p>
                  <p class="text-sm text-secondary">No chat selected.</p>
                  }
                </div>
                <div class="h-full flex flex-col justify-between items-end">
                  <button type="button" (click)="closeDrawer()" class="btn-fab-secondary text-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="size-5">
                      <path d="M18 6 6 18" />
                      <path d="m6 6 12 12" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="relative h-full flex-1 flex-col w-full overflow-hidden drawer-body-primary divide-y divide-border">
              <div class="h-full overflow-y-auto scrollbar-transparent">
                @if (channel) {
                <ul role="list" class="divide-y divide-border">
                  @for (member of membersList(channel); track member.id) {
                  <li class="flex items-center gap-3 py-3 px-2">
                    <span class="h-2.5 w-2.5 shrink-0 rounded-full" [class.bg-emerald-500]="member.online"
                      [class.bg-zinc-400]="!member.online" aria-hidden="true"></span>
                    <span class="min-w-0 flex-1 text-sm text-primary">{{ member.name }}</span>
                  </li>
                  } @empty {
                  <li class="px-2 py-8 text-sm text-center text-secondary">No members in this channel.</li>
                  }
                </ul>
                } @else {
                <div class="px-2 py-8 text-sm text-center text-secondary">Select a chat to see members.</div>
                }
              </div>
            </div>
          </div>
        </div>
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>